import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { IProgressbarEvent } from "./progressbar.interface";

@Component({
	selector: "rbc-progressbar",
	template: `
		<div
			class="rbc-progressbar"
			[ngClass]="snackbar ? 'rbc-snackbar-progressbar' : ''">
			<div
				[id]="id"
				[ngClass]="[
					'rbc-progressbar-' + size,
					round ? 'rbc-progressbar-round' : ''
				]"
				[attr.aria-describedby]="ariaDescribedBy"
				[attr.aria-label]="progress"
				class="rbc-progressbar-bar"
			>
				<div
					[style.width]="progress +'%'"
					class="rbc-progressbar-fill"
				></div>
			</div>
		</div>
	`,
	styles: []
})
export class ProgressbarComponent implements OnInit, OnDestroy, OnChanges {
	/**
	 * Progress Bar ID.
	 */
	@Input() id: string;

	/**
	 * ARIA "described-by" value.
	 */
	@Input() ariaDescribedBy: string;

	/**
	 * Progress value in % from 0 to 100.
	 */
	@Input() progress: number;

	/**
	 * Display Progress Bar with round corners.
	 */
	@Input() round: boolean | string = false;

	/**
	 * Progress Bar size.
	 */
	@Input() size: "large" | "medium" | "small" = "medium";

	/**
	 * Adjust appearance to match snackbar component.
	 */
	@Input() snackbar = false;

	/**
	 * Progress bar update event.
	 */
	@Output() progressbarupdate = new EventEmitter<IProgressbarEvent>();

	constructor(private idService: IdService) {}

	/**
	 * Ensure ID is present & emit update event.
	 */
	public ngOnInit(): void {
		if (!this.id) {
			this.id = this.idService.generate();
		}

		this.emitProgressBarEvent();
	}

	/**
	 * Emit update even upon detecting changes.
	 *
	 * @param changes
	 */
	public ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.progress && !changes.progress.firstChange) {
			this.emitProgressBarEvent();
		}
	}

	/**
	 * Remove ID from ID Service.
	 */
	public ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	/**
	 * Emit progress bar update event.
	 */
	private emitProgressBarEvent(): void {
		this.progressbarupdate.emit({
			id: this.id,
			progress: this.progress,
			self: this
		});
	}
}
